import { NetworkPopUpType } from '../../network.pop-up.factory';
import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { GzIocScanWebComponent } from './component/GzIocScanWebComponent';
import { translateFn } from '../../../../utils/translator.helper';
import { TaskType } from '../../../../tasks/networkTasks/types';
import { NetworkPopUpFooterContentWebComponent } from '../NetworkPopUpFooterContentWebComponent';
import { CreateTaskRequest } from '../../types';
import { IocScanRequestRules, IocScanTaskSpecifics } from './component/types';

export class IocScanPopUp extends NetworkBasePopUp<GzIocScanWebComponent> {
  private type = NetworkPopUpType.IOC_SCAN;
  protected title = translateFn('IOC scan');
  protected transformToTaskTarget = true;
  protected extraDialogConfigs: Partial<GzDialog> = {
    isWindow: true,
  };

  protected customSetup() {
    this.popUpFooterContent = new NetworkPopUpFooterContentWebComponent();
    this.popUpFooterContent.confirmButtonDisabled = true;

    this.popUpContent = new GzIocScanWebComponent();
    this.popUpContent.targets = this.transformProtectedEntitiesToTargetEntities();
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    const requestRules: IocScanRequestRules = this.popUpContent.getRequestData();
    const requestTargets = this.popUpContent.targets;

    const request: CreateTaskRequest<IocScanTaskSpecifics> = {
      settings: {
        specifics: {
          rules: [requestRules],
        },
        targets: requestTargets,
        taskName: requestRules.name,
        type: TaskType.TASK_TYPE_IOC_SCAN_PARENT,
      },
    };

    await this.createTask<IocScanTaskSpecifics>(request);
  }

  protected handleCancelButtonClicked(event: CustomEvent<any>): void {
    return;
  }
}
